/* global localStorage */
import R from 'ramda'
import * as types from '../constants/ActionTypes'
import { initAxios } from 'utils'

let token = '';

try {
  token = localStorage.getItem('token');
} catch(e) {
  console.error('No auth token found');
}

const removeToken = () => {
  initAxios()
  localStorage.removeItem('token')
};

const initialState = {
  authenticated: !!token,
};

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case types.USER_LOGIN:
      return { ...state, authenticated: true };
    case types.USER_LOGOUT_START:
      return { ...state, authenticated: false };
    default:
      if (
        (
          R.path(['payload', 'error', 'response', 'data', 'error', 'error-code'], action) ||
          R.path(['payload', 'error', 'data', 'error', 'error-code'], action)
        ) === 'USER_HAS_NOT_PERMISSION'
      ) {
        removeToken(); // TODO: Move into separate middleware
        return { ...state, authenticated: false };
      }
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.js